/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosProgressEvent } from "axios";
import instance from "../axiosConfig";

export class AssetsService {
    create = async (form: FormData): Promise<any> => {
        const response = await instance.postForm<any>(`api/admin/assets/imageeditor`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return response.data;
    };

    createWithProgress = async (
        form: FormData,
        controller?: AbortController,
        onUploadProgress?: (event: AxiosProgressEvent) => void
    ): Promise<any> => {
        const response = await instance.postForm<any>(`api/admin/assets/imageeditor`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            signal: controller?.signal,
            onUploadProgress,
        });

        return response.data;
    };
}
